module.exports = __webpack_public_path__ + "static/img/marketingInAsiaStartup.3f62c3bc.png";